import React from 'react';
import { Switch, Text, VStack, HStack, Spinner } from 'native-base';
import { theme } from '@breakroom-nx/assets';

export interface ToggleSwitchProps {
  title: string;
  description?: string;
  disabled: boolean;
  on: boolean;
  onToggle: () => void;
  isLoading?: boolean;
}

export function ToggleSwitch({
  title,
  description,
  disabled,
  on,
  onToggle,
  isLoading = false,
}: ToggleSwitchProps) {
  return (
    <HStack justifyContent={'space-between'} space={5} width={'full'}>
      <VStack flex={1} space={2}>
        <Text
          fontFamily={'heading'}
          fontSize={'lg'}
          color={theme.colors.purple[200]}
          fontWeight={600}
        >
          {title}
        </Text>
        {description && (
          <Text
            fontFamily={'heading'}
            fontSize={'md'}
            color={theme.colors.surface[500]}
            fontWeight={'regular'}
          >
            {description}
          </Text>
        )}
      </VStack>
      {isLoading ? (
        <Spinner size={'sm'} />
      ) : (
        <Switch
          disabled={disabled}
          isChecked={on}
          onToggle={onToggle}
          offTrackColor={'surface.200'}
        />
      )}
    </HStack>
  );
}

export default ToggleSwitch;
